import { createSlice } from '@reduxjs/toolkit'
import {
    ALL_PERMISSIONS,
    PERMISSIONS,
    CAR_PORTAL_MINIMAL_PERMISSIONS,
} from 'constants/permissions.constant'

export const initialState = {
    avatar: '',
    userName: '',
    email: '',
    authority: [],
    permissions: [],
}

export const calculatePermissions = (mediatorData) => {
    if (!mediatorData) return []

    let permissions = [...ALL_PERMISSIONS]

    const isCarPortal = mediatorData?.is_car_portal || false

    if (!isCarPortal) {
        permissions = permissions.filter(
            (p) => p !== PERMISSIONS.VIEW_CAR_CASES
        )
    } else {
        const stripeId = mediatorData?.stripeId
        const zoomToken = mediatorData?.zoom?.token || null
        if (!stripeId || !zoomToken) {
            permissions = CAR_PORTAL_MINIMAL_PERMISSIONS
        }
    }

    if (mediatorData?.status === 'inactive') {
        return [PERMISSIONS.VIEW_ACCOUNT]
    }

    return permissions
}

export const userSlice = createSlice({
    name: 'auth/user',
    initialState,
    reducers: {
        setUser: (_, action) => {
            const payload = action.payload
            if (!payload) return initialState

            return {
                ...payload,
                permissions: payload.permissions || [],
            }
        },
        userLoggedOut: () => initialState,
    },
})

export const { setUser } = userSlice.actions

export const userPermissionsSelector = (state) =>
    state.auth.user?.permissions || []

export const isCarPortalSelector = (state) =>
    Boolean(state.auth.user?.is_car_portal)

export const hasCarPortalMinimalPermissionsSelector = (state) => {
    const user = state.auth.user
    if (!user) return false

    const isCarPortal = user?.is_car_portal || false
    const stripeId = user?.stripeId || user?.stripe_session?.stripe_id || null
    const zoomToken = user?.zoom?.token || null

    return isCarPortal && (!stripeId || !zoomToken)
}

export const mediatorDataSelector = (state) => {
    const data = state.auth.user
    if (data) {
        return {
            invoiceMemo: data?.invoiceMemo,
            mediationRates: data?.mediationRates,
            mediationTime: data?.mediationTime,
            mediator_id: data?.mediator_id,
            profile: data?.profile,
            reminderDays: data?.reminderDays,
            stripeId: data?.stripeId,
            user_id: data?.user_id,
            is_odr_mediator: data?.is_odr_mediator || false,
        }
    }

    return null
}

export default userSlice.reducer
